export const featuredPortfolio = [
    {
      id: 1,
      title: "Chatting Web-App",
      img:
        "https://tse3.mm.bing.net/th?id=OIP.s1MvxCJgo77ijjC_LkZxXAHaEo&pid=Api&P=0&w=240&h=150",
    },
    {
      id: 2,
      title: "My startup",
      img:
        "https://tse2.mm.bing.net/th?id=OIP.PNLeu1qEjWM-a5yhtSrgEAEsCo&pid=Api&P=0&w=290&h=163",
    },
    {
      id: 3,
      title: "My Portfolio",
      img:
        "https://tse1.mm.bing.net/th?id=OIP.CUYN0VuLkIZZ6LQZ9tXBvQHaE7&pid=Api&P=0&w=254&h=168",
    },
    {
      id: 4,
      title: "Image detector",
      img:
        "https://tse1.mm.bing.net/th?id=OIP.RWCyHaNB-TE95fTfiWGZMwHaDt&pid=Api&P=0&w=345&h=172",
    },
    
  ];
  
  export const webPortfolio = [
    {
      id: 1,
      title: "Chatting App",
      img: "https://tse3.mm.bing.net/th?id=OIP.s1MvxCJgo77ijjC_LkZxXAHaEo&pid=Api&P=0&w=240&h=150",
    },
    
  ];
  
  export const designPortfolio = [
    {
      id: 1,
      title: "Mobile Social Media App",
      img:
        "https://tse4.mm.bing.net/th?id=OIP.EeZQNxbf-XfBFSU90oPAvQHaEu&pid=Api&P=0&w=332&h=212",
    },
    
  ];

  export const apiPortfolio = [
      {
          id: 1,
          title: "Image Detection",
          img: "https://tse3.mm.bing.net/th?id=OIP.20rcBdcpk87QxRj0dtPdOgHaEg&pid=Api&P=0&w=340&h=207"
      },
  ]
  
  
  
  